import { handleActions } from 'redux-actions';
import { actions as loadsActions } from 'state/loads';
import reducersUtils from 'state/utils';
import { removeDuplicates } from 'utils/array';
import actions from 'state/shipments/actionCreators';

import initialState, { defaultShipment } from 'state/shipments/initial.state';

const shipmentHandlers = {
  [actions.addShipment]: (state, { payload: { shipmentKey, values } }) => ({
    ...defaultShipment,
    shipmentKey,
    ...values,
  }),
  [actions.changeValues]: (state, { payload: { values } }) => ({
    ...state,
    ...values,
  }),
  [actions.setExtra]: (state, { payload: { extra } }) => ({
    ...state,
    extras:
      state.extras.indexOf(extra) < 0
        ? [...state.extras, extra]
        : state.extras.filter((elem) => elem !== extra),
  }),
  [loadsActions.addLoad]: (state, { payload: { loadKey } }) => ({
    ...state,
    loads: removeDuplicates([...state.loads, loadKey]),
  }),
  [loadsActions.removeLoad]: (state, { payload: { loadKey } }) => ({
    ...state,
    loads: [...reducersUtils.removeKeyFrom.array(state.loads, loadKey)],
  }),
  [actions.cleanCommentsAndInternalReference]: (state) => ({
    ...state,
    internal_reference: false,
    load_extra_info: '',
    pickup_comment_from_shipper_to_driver:
      state.pickup_comment_from_shipper_to_driver === ''
        ? false
        : state.pickup_comment_from_shipper_to_driver,
    dropoff_comment_from_shipper_to_driver:
      state.dropoff_comment_from_shipper_to_driver === ''
        ? false
        : state.dropoff_comment_from_shipper_to_driver,
  }),
  [actions.setCommentForTransportist]: (
    state,
    { payload: { commentForTransportist, stopType } }
  ) => ({
    ...state,
    [`${stopType}_comment_from_shipper_to_driver`]: commentForTransportist,
  }),
  [actions.setInternalReference]: (
    state,
    { payload: { internalReference } }
  ) => ({
    ...state,
    internal_reference: internalReference,
  }),
  [actions.setAppointmentInstructions]: (state, { payload: { value } }) => ({
    ...state,
    appointment_instructions: value,
  }),
};

const reducerItemOptions = {
  handlers: shipmentHandlers,
  key: 'shipmentKey',
};

const shipment = (state, action, forAll = false) =>
  reducersUtils.reducerItem(state, action, { ...reducerItemOptions, forAll });

const shipments = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [actions.addShipment]: (state, action) => ({
      ...state,
      [action.payload.shipmentKey]: shipment(undefined, action),
    }),
    [actions.removeShipment]: (state, { payload: { shipmentKey } }) =>
      Object.keys(state).length <= 1
        ? { ...state }
        : { ...reducersUtils.removeKeyFrom.object(state, shipmentKey) },
    [actions.changeValues]: (state, action) => ({
      ...state,
      [action.payload.shipmentKey]: shipment(
        state[action.payload.shipmentKey],
        action
      ),
    }),
    [actions.setExtra]: (state, action) => ({
      ...state,
      [action.payload.shipmentKey]: shipment(
        state[action.payload.shipmentKey],
        action
      ),
    }),
    [loadsActions.addLoad]: (state, action) => ({
      ...state,
      [action.payload.shipmentKey]: shipment(
        state[action.payload.shipmentKey],
        action
      ),
    }),
    [loadsActions.removeLoad]: (state, action) => ({
      ...state,
      [action.payload.shipmentKey]: shipment(
        state[action.payload.shipmentKey],
        action
      ),
    }),
    [actions.cleanCommentsAndInternalReference]: (state, action) => ({
      ...state,
      [action.payload.shipmentKey]: shipment(
        state[action.payload.shipmentKey],
        action
      ),
    }),
    [actions.setCommentForTransportist]: (state, action) => ({
      ...state,
      [action.payload.shipmentKey]: shipment(
        state[action.payload.shipmentKey],
        action
      ),
    }),
    [actions.setInternalReference]: (state, action) => ({
      ...state,
      [action.payload.shipmentKey]: shipment(
        state[action.payload.shipmentKey],
        action
      ),
    }),
    [actions.setAppointmentInstructions]: (state, action) => ({
      ...state,
      [action.payload.shipmentKey]: shipment(
        state[action.payload.shipmentKey],
        action
      ),
    }),
  },
  initialState
);

export default shipments;
